import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, map, tap } from 'rxjs/operators';
import { ApiService } from 'projects/access-control/src/app/Infrastructure/Services/api.service';
import { of } from 'rxjs';
import {
	deleteClient,
	deleteClientError,
	deleteClientSuccess,
	deleteModuleOneClient,
	deleteModuleOneClientError,
	deleteModuleOneClientSuccess,
	getClient,
	getClientError,
	getClientResourcesSearchModule,
	getClientResourcesSearchModuleError,
	getClientResourcesSearchModuleSuccess,
	getClientSuccess,
	getModuleOneClient,
	getModuleOneClientError,
	getModuleOneClientSuccess,
	getResourcesModuleClient,
	getResourcesModuleClientError,
	getResourcesModuleClientSuccess,
	postClient,
	postClientError,
	postClientSuccess,
	postModuleClient,
	postModuleClientError,
	postModuleClientSuccess,
	searchClient,
	searchClientError,
	searchClientSuccess,
	updateClient,
	updateClientError,
	updateClientSuccess,
	updateModuleOneClient,
	updateModuleOneClientError,
	updateModuleOneClientSuccess,
} from './clients.action';
import { ClientService } from './clients.service';
import { ToastAlert } from 'projects/access-control/src/app/Infrastructure/hooks/toast.hook';
import { TranslateService } from '@mangosoft/mango-layout';

@Injectable()
export class ClientEffects {
	dataTranslate: any;
	constructor(
		private actions$: Actions,
		private api: ApiService,
		private clientService: ClientService,
		private toastAlert: ToastAlert,
		private translateService: TranslateService
	) {
		this.translateService.init('AccessControl').subscribe((data) => {
			this.dataTranslate = data.pages.clients.toasts;
		});
	}

	getClient$ = createEffect(() =>
		this.actions$.pipe(
			ofType(getClient),
			concatMap(() =>
				this.clientService.getAllClient().pipe(
					map((client) => getClientSuccess({ client })),
					catchError((error) => of(getClientError({ error })))
				)
			)
		)
	);

	searchClient$ = createEffect(() =>
		this.actions$.pipe(
			ofType(searchClient),
			concatMap(({ search }) =>
				this.clientService.searchClient(search).pipe(
					map(({ data: client }) => searchClientSuccess({ client })),
					catchError((error) => of(searchClientError({ error })))
				)
			)
		)
	);
	getModuleOneClient$ = createEffect(() =>
		this.actions$.pipe(
			ofType(getModuleOneClient),
			concatMap(({ pk, sk }) =>
				this.clientService.getModuleOneClient(pk, sk).pipe(
					map(({ data }) => getModuleOneClientSuccess({ module: data.module, client: data })),
					catchError((error) => of(getModuleOneClientError({ error })))
				)
			)
		)
	);

	getResourcesModuleOneClient$ = createEffect(() =>
		this.actions$.pipe(
			ofType(getResourcesModuleClient),
			concatMap(({ url, pkClient, skClient }) =>
				this.clientService.getResource(url).pipe(
					map(({ pagination, data }) =>
						getResourcesModuleClientSuccess({
							pagination,
							pk: data.module.pk,
							resource: data.resources,
							pkClient,
							skClient,
						})
					),
					catchError((error) => of(getResourcesModuleClientError({ error })))
				)
			)
		)
	);

	getResourceSearch$ = createEffect(() =>
		this.actions$.pipe(
			ofType(getClientResourcesSearchModule),
			concatMap(({ url, search, pkClient, skClient }) =>
				this.clientService.getResourceSearch(url, search).pipe(
					map(({ data, pagination }) =>
						getClientResourcesSearchModuleSuccess({
							pagination,
							pk: data.module.pk,
							resource: data.resources,
							pkClient,
							skClient,
						})
					),
					catchError((error) => of(getClientResourcesSearchModuleError({ error })))
				)
			)
		)
	);

	deleModuleOneClient$ = createEffect(() =>
		this.actions$.pipe(
			ofType(deleteModuleOneClient),
			concatMap(({ data, params }) =>
				this.clientService.deleteModuleOneClient(params, data).pipe(
					map(({ data }) =>
						deleteModuleOneClientSuccess({ module: data.module, client: data.client })
					),
					catchError((error) => of(deleteModuleOneClientError({ error })))
				)
			)
		)
	);
	addClient$ = createEffect(() =>
		this.actions$.pipe(
			ofType(postClient),
			concatMap(({ client }) =>
				this.clientService.createClient(client).pipe(
					map((client) => postClientSuccess({ client: client.data.client })),
					catchError((error) => of(postClientError({ error })))
				)
			)
		)
	);
	updateClient$ = createEffect(() =>
		this.actions$.pipe(
			ofType(updateClient),
			concatMap(({ params, client }) =>
				this.clientService.updateClient(params, client).pipe(
					map((client) => updateClientSuccess({ client: client.data.client })),
					catchError((error) => of(updateClientError({ error })))
				)
			)
		)
	);
	addModuleClient$ = createEffect(() =>
		this.actions$.pipe(
			ofType(postModuleClient),
			concatMap(({ params, module }) =>
				this.clientService.createModuleClient(params, module).pipe(
					map(({ data }) => postModuleClientSuccess({ module: data.module, client: data.client })),
					catchError((error) => of(postModuleClientError({ error })))
				)
			)
		)
	);
	updateModuleClient$ = createEffect(() =>
		this.actions$.pipe(
			ofType(updateModuleOneClient),
			concatMap(({ params, module }) =>
				this.clientService.updateModuleClient(params, module).pipe(
					map(({ data }) =>
						updateModuleOneClientSuccess({ client: data.client, module: data.module })
					),
					catchError((error) => of(updateModuleOneClientError({ error })))
				)
			)
		)
	);
	deleteClient$ = createEffect(() =>
		this.actions$.pipe(
			ofType(deleteClient),
			concatMap(({ pk, sk }) =>
				this.clientService.deleteClient(pk, sk).pipe(
					map((client) => deleteClientSuccess({ client: client.data.client })),
					catchError((error) => of(deleteClientError({ error })))
				)
			)
		)
	);
	updateClientSuccess$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(updateClientSuccess),
				tap((action) => {
					this.toastAlert.toastSuccess(
						this.dataTranslate.toastUpdateTitle,
						this.dataTranslate.toastUpdateDescription
					);
				})
			),
		{ dispatch: false }
	);
	createClientSuccess$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(postClientSuccess),
				tap((action) => {
					this.toastAlert.toastSuccess(
						this.dataTranslate.toastCreateTitle,
						this.dataTranslate.toastCreateDescription
					);
				})
			),
		{ dispatch: false }
	);
	deleteClientSuccess$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(deleteClientSuccess),
				tap((action) => {
					this.toastAlert.toastSuccess(
						this.dataTranslate.toastDeleteTitle,
						this.dataTranslate.toastDeleteDescription
					);
				})
			),
		{ dispatch: false }
	);

	deleteModuleClientSuccess$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(deleteModuleOneClientSuccess),
				tap((action) => {
					this.toastAlert.toastSuccess(
						this.dataTranslate.toastDeleteModuleTitle,
						this.dataTranslate.toastDeleteModuleDescription
					);
				})
			),
		{ dispatch: false }
	);

	postModuleClientSuccess$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(postModuleClientSuccess),
				tap((action) => {
					this.toastAlert.toastSuccess(
						this.dataTranslate.toastCreateModuleTitle,
						this.dataTranslate.toastCreateModuleDescription
					);
				})
			),
		{ dispatch: false }
	);

	updateModuleClientSuccess$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(updateModuleOneClientSuccess),
				tap((action) => {
					this.toastAlert.toastSuccess(
						this.dataTranslate.toastUpdateModuleTitle,
						this.dataTranslate.toastUpdateModuleDescription
					);
				})
			),
		{ dispatch: false }
	);
	ClientsError$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(
					getClientError,
					getModuleOneClientError,
					deleteClientError,
					deleteModuleOneClientError,
					postClientError,
					postModuleClientError,
					updateClientError,
					updateModuleOneClientError,
					searchClientError
				),
				tap(({ error }) => {
					const msgError = error.error.errorMessage || 'Internal Error ';
					this.toastAlert.toastFailure('Error', msgError);
				})
			),
		{ dispatch: false }
	);
}
